import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getContentOnlySearchResults({ content }: Props) {
  const { heroSearch } = content;
  return heroSearch && heroSearch.onlyResults;
}
